export default {
  '0001': 'El enlace ha expirado, por favor descargue el archivo nuevamente',
  'TITLE_TAB': 'Encuestas',
  'TITLE': 'Encuestas',
  'QUESTIONNAIRE_SELECTOR_TITLE': 'Campaña',
  'SINGLE_CHOICE_QUESTION': 'Pregunta con una sola opción a elegir',
  'ANSWER_WITH_COUNT': '{{count}} respuesta',
  'ANSWER_WITH_COUNT_plural': '{{count}} respuestas',
  'STAR_WITH_COUNT': '{{count}} estrella',
  'STAR_WITH_COUNT_plural': '{{count}} estrellas',
  'MULTIPLE_CHOICE_QUESTION': 'Pregunta con múltiples opciones a elegir',
  'OPEN_QUESTION': 'Pregunta abierta',
  'RATING_QUESTION': 'Pregunta con calificación',
  'TOTAL_ANSWERS': '{{answers}} en total',
  'DOWNLOAD_TITLE': 'Descargar las respuestas de tus clientes',
  'DOWNLOAD_BUTTON': 'Enviar a correo electrónico',
  'DOWNLOAD_SUCCESS_MESSAGE': 'Estamos procesando su descarga recibirá en breve un correo con el enlace',
}
